import { API, Storage } from 'aws-amplify';

function cleanEmptyValue(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === '') {
      // eslint-disable-next-line no-param-reassign
      delete obj[key];
    }
  });

  return obj;
}

export const create = async member => API.put('cmseinkaufskreisApi', '/companies', { body: cleanEmptyValue(member) });

export const read = async () => API.get('cmseinkaufskreisApi', '/companies', {});

export const update = async member => API.post('cmseinkaufskreisApi', `/companies/${member.id}`, {
  body:
    cleanEmptyValue(member),
});

export const del = async member => API.del('cmseinkaufskreisApi', `/companies/${member.id}`, {});

// eslint-disable-next-line max-len
export const uploadMemberImage = async (title, image) => Storage.put(`public/member/${title}`, image, { contentType: image.type });
